import React from 'react';

import styled from '@emotion/styled';

interface TableScrollerProps {
  children: React.ReactNode;
}

const TableScroller: React.FC<TableScrollerProps> = ({ children }) => {
  return (
    <Container>
      <Scroller>{children}</Scroller>
    </Container>
  );
};

export default TableScroller;

const Container = styled.div`
  display: flex;
  width: 100%;
  background-color: #fafafa;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 16px;
`;

const Scroller = styled.div`
  overflow-x: auto;
  width: 100%;
`;
